import {
    createModule, createModuleSection, getModulesAdminByAuthor, getModuleSectionsAdmin,
} from "./subjects";

const moduleFields = ["moduleSlug", "title", "order", "enabled", "questions", "sections",
    "pdfPath", "pdfFileName", "sectionSlug", "sectionTitle", "sectionDescription", "sectionOrder", "sectionIconKey"];
const sectionFields = ["sectionSlug", "title", "description", "order", "enabled", "iconKey"];
const pick = (record, fields) => JSON.parse(JSON.stringify(Object.fromEntries(
    fields.filter((field) => record[field] !== undefined).map((field) => [field, record[field]])
)));
const canonical = (value) => JSON.stringify(value, function (key, item) {
    return item && typeof item === "object" && !Array.isArray(item)
        ? Object.fromEntries(Object.keys(item).sort().map((name) => [name, item[name]])) : item;
});

export async function prepareModuleCopy(source, target) {
    if (source.map(String).join("/") === target.map(String).join("/")) {
        throw new Error("Оберіть іншого автора-джерело.");
    }
    const [modules, sections, targetModules, targetSections] = await Promise.all([
        getModulesAdminByAuthor(...source), getModuleSectionsAdmin(...source),
        getModulesAdminByAuthor(...target), getModuleSectionsAdmin(...target),
    ]);
    if (targetModules.length) throw new Error("У цільового автора вже є модулі.");
    if (!modules.length) throw new Error("У джерела немає модулів.");
    if (sections.some((section) => targetSections.some((item) => item.sectionSlug === section.sectionSlug))) {
        throw new Error("У цільового автора вже є секції з такими самими ідентифікаторами.");
    }
    return {
        target: [...target], modulesTotal: modules.length, sectionsTotal: sections.length,
        completed: 0, started: false,
        items: [
            ...sections.map((section) => ({ kind: "section", payload: pick(section, sectionFields) })),
            ...modules.map((module) => ({ kind: "module", payload: pick(module, moduleFields) })),
        ],
    };
}

// The dialog retains the plan after a failure so confirmed writes are not repeated.
export async function runModuleCopy(plan, onProgress) {
    if (!plan.started) {
        const existing = await getModulesAdminByAuthor(...plan.target);
        if (existing.length) throw new Error("У цільового автора вже є модулі. Оновіть список.");
        plan.started = true;
    }
    while (plan.completed < plan.items.length) {
        const item = plan.items[plan.completed];
        const isModule = item.kind === "module";
        const slugKey = isModule ? "moduleSlug" : "sectionSlug";
        const list = isModule ? getModulesAdminByAuthor : getModuleSectionsAdmin;
        // A lost response can mean the POST succeeded. Reconcile before retrying it.
        if (item.attempted) {
            const existing = (await list(...plan.target)).find((record) => record[slugKey] === item.payload[slugKey]);
            if (existing) {
                if (canonical(pick(existing, Object.keys(item.payload))) !== canonical(item.payload)) {
                    throw new Error(`Конфлікт: «${item.payload.title}» вже існує з іншим вмістом. Перевірте цільового автора.`);
                }
                plan.completed += 1;
                onProgress(plan.completed);
                continue;
            }
        }
        item.attempted = true;
        await (isModule ? createModule : createModuleSection)(...plan.target, item.payload);
        plan.completed += 1;
        onProgress(plan.completed);
    }
    return { modulesCopied: plan.modulesTotal, sectionsCopied: plan.sectionsTotal };
}
